module.exports = __webpack_public_path__ + "img/skill-shape-1.541b83b3.png";